var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Hashtag",

    getDefaultProps () {
        return {"data-svgreactloader":"[[null,\"rdf\",\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"],[\"http://www.w3.org/2000/svg\",\"cc\",\"http://creativecommons.org/ns#\"],[\"http://www.w3.org/2000/svg\",\"dc\",\"http://purl.org/dc/elements/1.1/\"]]","xmlns":"http://www.w3.org/2000/svg","height":"64","width":"64","version":"1.1","viewBox":"0 0 64.000001 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g transform="translate(0 -988.36)">
    <path data-svgreactloader="[[null,&quot;style&quot;,&quot;color-rendering:auto;text-decoration-color:#000000;color:#000000;isolation:auto;mix-blend-mode:normal;shape-rendering:auto;solid-color:#000000;block-progression:tb;text-decoration-line:none;text-decoration-style:solid;image-rendering:auto;white-space:normal;text-indent:0;text-transform:none&quot;]]" d="m27.471 1003.3a2.0002 2.0002 0 0 0 -1.9316 1.6368l-1.2773 6.3906h-5.7617a2.0002 2.0002 0 1 0 0 4h4.9609l-2 10h-5.9609a2.0002 2.0002 0 1 0 0 4h5.1602l-1.1211 5.6094a2.0002 2.0002 0 1 0 3.9219 0.7832l1.2793-6.3926h9.9199l-1.1211 5.6094a2.0002 2.0002 0 1 0 3.9219 0.7832l1.2793-6.3926h6.7598a2.0002 2.0002 0 1 0 0 -4h-5.9609l2-10h6.9609a2.0002 2.0002 0 1 0 0 -4h-6.1602l1.1211-5.6074a2.0002 2.0002 0 0 0 -1.9902 -2.42 2.0002 2.0002 0 0 0 -1.9316 1.6368l-1.2773 6.3906h-9.9219l1.1211-5.6074a2.0002 2.0002 0 0 0 -1.9902 -2.42zm0.06836 12.027h9.9219l-2 10h-9.9219l2-10z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/hashtag.svg